import axios from 'axios'
import { API_URL } from './index'
import { FOLLOW_USER, UNFOLLOW_USER, VIEW_FOLLOWERS, VIEW_FOLLOWING } from '../constants/ActionTypes'

const fetchFollowers = (user_id, response) => {
	return {
		type: VIEW_FOLLOWERS,
		user_id,
		payload: response.data
	}
}

const fetchFollowing = (user_id, response) => {
	return {
		type: VIEW_FOLLOWING,
		user_id,
		payload: response.data
	}
}

export const followUser = (user_id, cb, loadUser) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Authorization': authorization}}
	
	let url = `${API_URL}/users/follow/` + user_id
	axios.post(url, null, headers)
	.then((response) => {
		cb()
		loadUser(user_id)
	})
	.catch((error) => {
		console.log(error)
	})
}

export const unfollowUser = (user_id, cb, loadUser) => (dispatch, getState) => {
	let token = getState().auth.token
	let authorization = "Bearer " + token
	let headers = {headers:{'Authorization': authorization}}
	
	let url = `${API_URL}/users/follow/` + user_id
	axios.delete(url, headers)
	.then((response) => {
		cb()
		loadUser(user_id)
	})
	.catch((error) => {
		console.log(error)
	})
}

export const viewFollowers = (user_id) => (dispatch, getState) => {
	let url = `${API_URL}/users/followers/` + user_id
	axios.get(url)
	.then((response) => {
		dispatch(fetchFollowers(user_id, response))
	})
	.catch((error) => {
		console.log(error)	
	})
}

export const viewFollowing = (user_id) => (dispatch, getState) => {
	let url = `${API_URL}/users/following/` + user_id
	axios.get(url)
	.then((response) => {
		dispatch(fetchFollowing(user_id, response))
	})
	.catch((error) => {
		console.log(error)	
	})
}


// WEBPACK FOOTER //
// ./src/actions/follow.js